import styled from "styled-components"

export const ApplicationHeaderPortal = styled.div`
  margin-left: -14px;
`
